import React from 'react';

import { Col } from '@/components/Col';
import { Row } from '@/components/Row';
import type { ContentfulContentGroupFragment } from '@/graphql/contentful/api';
import type { CmsExtraDataRecord } from '@/integrations/contentful';
import { generateSectionKey } from '@/integrations/contentful';
import type { ContentfulData } from '@/integrations/contentful/types';

import { type ItemData, renderCollectionItem } from './cms';

type MyAccountCardGroupProps = ContentfulContentGroupFragment & {
  extraDataRecord?: CmsExtraDataRecord;
};

export const MyAccountCardGroup = ({
  extraDataRecord,
  itemsCollection,
}: MyAccountCardGroupProps) => {
  return (
    <Row showRowGap>
      {itemsCollection?.items.filter(Boolean).map((item, i, array) => {
        const props = (item ? { ...item, preload: true } : null) as ItemData;
        const xsGridColSpan = array.length > 3 && i % 3 !== 0 ? 6 : 12;
        const renderedItem = renderCollectionItem(props, extraDataRecord);
        return (
          renderedItem && (
            <Col
              key={`${generateSectionKey(item as ContentfulData, i)}`}
              data-testid={`MyAccountCardCol-${i}`}
              md={12 / array.length}
              xs={xsGridColSpan}
            >
              {renderedItem}
            </Col>
          )
        );
      })}
    </Row>
  );
};

MyAccountCardGroup.displayName = 'MyAccountCardGroup';
